module.exports = __webpack_public_path__ + "static/hair-salon-white-glove-054fd196ac371d562c2abeb66ad749b6.png";